import clsx from 'clsx';
import React from 'react';
import { useCreateOperator } from '../../../contexts/CreateOperatorContext';
import { ProgressStepSummary } from '../../../hooks/useProgress';
import { CheckCircle, Error, Warning } from '@material-ui/icons';
import { Tooltip } from '../../../components/Tooltip';

export const ResultsSummary = () => {
  const { summary } = useCreateOperator();

  if (summary.length === 1) return null;

  const renderStepStatus = (step: ProgressStepSummary) => {
    if (step.error && step.completed === false)
      return <Error className="text-error" />;
    else if (step.error && step.completed)
      return (
        <Tooltip title="Completed with errors">
          <Warning className="text-warning" />
        </Tooltip>
      );
    return <CheckCircle className="text-success" />;
  };

  return (
    <>
      <p className="text-lg">Summary:</p>
      <ol className="flex flex-col gap-4 list-none p-4">
        {summary.map((step, index) => (
          <li key={`step-summary-${index + 1}`} className="block">
            <div
              className={clsx('relative inline-flex items-center gap-2', {
                ['before:absolute before:left-3 before:top-[24px] before:h-[calc(100%+10px)] before:border-l before:border-border-light before:dark:border-border-dark']:
                  summary.length !== index + 1,
              })}
            >
              {renderStepStatus(step)}
              {step.name}
            </div>
            {step.error ? (
              <p
                className={clsx('text-xs ml-8', {
                  ['text-error']:
                    step.error !== null && step.completed === false,
                  ['text-warning']: step.error !== null && step.completed,
                })}
              >
                {step.error}
              </p>
            ) : null}
          </li>
        ))}
      </ol>
    </>
  );
};
